import classNames from 'classnames';
import { ClipLoader } from 'react-spinners';

export interface ICircleSpinner {
  loading?: boolean;
  size?: string;
  color?: string;
  className?: string;
}

const CircleSpinner: React.FC<ICircleSpinner> = ({
  loading,
  size,
  color,
  className,
}) => {
  return (
    <div className={classNames(className)}>
      <ClipLoader size={size} color={color} loading={loading} />
    </div>
  );
};

export default CircleSpinner;
